/**
 * Helper function to ensure exhaustive type checking for a switch statement.
 *
 * For example if you have a switch statement and you have a default case,
 * you can use this function to ensure that all cases are handled.
 *
 * @example
 * ```typescript
 * switch (value) {
 *   case 'a':
 *     break;
 *   default:
 *     UnreachableCaseStatement(value);
 * }
 * ```
 *
 * Anytime you update the `value` enum, `tsc` will fail to compile if you
 * have not updated the switch statement to handle the new value.
 */
export function UnreachableCaseStatement(x, enumObj) {
    throw new Error(`Unreachable case statement: ${JSON.stringify(x)}. Valid values are: ${Object.values(enumObj).join(', ')}`);
}
//# sourceMappingURL=unreachable-case-statement.js.map